import pageRoute from '@/libs/constant/pageRoutes'
import SelectDropdown from '@/components/component/Reuse/SelectDropdown/SelectDropdown.vue'
import AddShortUrl from '@/components/component/Reuse/AddShortUrl/AddShortUrl.vue'
import AddDomain from '@/components/component/Reuse/AddDomain/AddDomain.vue'
import { mapGetters }  from 'vuex';
import permissions from '@/libs/constant/permissions'
import {isEmpty} from 'lodash'

export default {
    name: 'ShortURLSettingRegisteredURL',
    components: {
        SelectDropdown,
        AddShortUrl,
        AddDomain
    },
    computed: {
        ...mapGetters(['hasPermission'])
    },

    props: {
        details: {
            type: Object,
            default: () => {}
        },
        activeUrls: {
            type: Array,
            default: () => []
        },
        archivedUrls: {
            type: Array,
            default: () => []
        },
        reportingGroups: {
            type: Array,
            default: () => []
        },
        domainList: {
            type: Array,
            default: () => []
        },
        fetchreportingGroups: {
            type: Function,
            default: () => {}
        },
        refreshShortUrlList: {
            type: Function,
            default: () => {}
        },
        totalCount: {
            type: Number,
            default: null,
        }
    },

    watch: {
        details (value) {
            if(value) {
            this.redirectionOptions[0].label =  `${this.details.type ? this.details.screen_name: this.details.name} > overview`
            }
        }
    },
    data () {
        return {
            registeredUrlDropdownValue: '',
            openAddShortUrl: false,
            addDomain: false,
            registeredUrl: false,
            description: "",
            name: "" ,
            redirectionOptions: [
                {
                    label: `${this.details.type ? this.details.screen_name: this.details.name} > overview`,
                    _id: '12345'
                }  
            ],
            selectedRedirection: '12345',
            permissions: permissions,
            isEmpty  
        }
    },

    methods: {
        /**
         * route to internal page
         */
         routeToInternalURLS (type) {
            switch (type) {
                case "ACTIVE":
                    this.$router.push({name: pageRoute.shortURLActiveURLS}).catch(() => {})
                break
                case "ARCHIVE":
                    this.$router.push({name: pageRoute.shortURLArchiveURLS}).catch(() => {})
                break
            }
        },
        closeAddShortUrlDialog () {
            this.openAddShortUrl = false
        },
        closeAddDomainDialog () {
            this.addDomain = false
        },
        
        closeRegisteredURLDialog () {
            this.name = ''
            this.description = ''
            this.registeredUrl = false
        },

        /**
         * create new reporting group
         */
        createUrlReportingGroup () {
            this.$emit('create-register-url', {
                name: this.name, 
                description: this.description
            })
            this.closeRegisteredURLDialog()
        },
        
    }
}